import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Button.css';

const getDisabledContainerStyle = (bordered, transparent) => {
  if (bordered) return 'button--bordered-disable';
  if (transparent) return 'button--transparent-disable';
  return 'button--disabled';
};

const getDisabledTextStyle = (bordered, transparent) => {
  if (bordered) return 'button__text--bordered-disable';
  if (transparent) return 'button__text--transparent-disable';
  return null;
};

export const Button = ({
  onClick,
  title,
  type,
  style,
  textStyle,
  className,
  textClassName,
  toggle,
  disabled,
  submitDisabled,
  block,
  inline,
  rounded,
  bordered,
  flat,
  transparent,
  children,
  light,
  withoutTextTransform,
  leftIcon,
}) => (
  <button
    type={type}
    disabled={disabled || submitDisabled}
    onClick={!disabled && !submitDisabled ? onClick : () => {}}
    className={classNames([
      'btn',
      block && 'btn-block',
      inline && 'btn-inline',
      rounded && 'btn-rounded',
      bordered && 'btn-outline-gray',
      flat && 'btn-lg',
      disabled && getDisabledContainerStyle(bordered, transparent),
      submitDisabled && 'button--submit-disabled',
      toggle && 'button--toggle',
      transparent && 'button--transparent button--flat',
      className,
    ])}
    style={style}
  >
    {children || (
      <span
        className={classNames([
          'btn-text',
          (bordered || transparent) && 'button__text--colored-text',
          disabled && getDisabledTextStyle(bordered, transparent),
          submitDisabled && 'button__text--submit-disabled',
          light && 'button__text--light',
          withoutTextTransform && 'button__text--without-text-transform',
          textClassName,
        ])}
        style={textStyle}
      >
        {leftIcon && (
          <img className="button__left-icon" alt="button text" src={leftIcon} />
        )}
        {title}
      </span>
    )}
  </button>
);

Button.defaultProps = {
  type: 'button',
};

Button.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.string,
  light: PropTypes.bool,
  block: PropTypes.bool,
  inline: PropTypes.bool,
  rounded: PropTypes.bool,
  bordered: PropTypes.bool,
  flat: PropTypes.bool,
  toggle: PropTypes.bool,
  disabled: PropTypes.bool,
  submitDisabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  transparent: PropTypes.bool,
  withoutTextTransform: PropTypes.bool,
  children: PropTypes.node,
  style: PropTypes.string,
  textStyle: PropTypes.string,
  className: PropTypes.string,
  textClassName: PropTypes.string,
  leftIcon: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Button/Button.js